import styled from "styled-components";

import { SelectInputOptionStyledProps as Props } from "./SelectInputOption.types";

const SelectInputOptionStyled = styled.div<Props>`
  .SelectInputOption {
    &__container {
      border-radius: 1.6rem;
      display: flex;
      align-items: center;
      flex: 1;
      padding: 1.6rem;
      justify-content: space-between;

      &:hover:not([disabled]) {
        background-color: var(--palette-mid-blue-s15-l20);
        border: none;
        box-shadow: none;
      }
    }

    &__active__container {
      background-color: var(--palette-mid-blue-s15-l20);
      border-radius: 1.6rem;
    }

    &__text {
      font-weight: 600;
      color: var(--palette-white);
      padding-left: 1.6rem;
      font-size: 1.6rem;
      line-height: 2.4rem;
    }

    &__selected {
      path {
        fill: var(--palette-primary);
      }
    }
  }
`;

export default SelectInputOptionStyled;
